import { ArrowLeft } from "lucide-react";
import { PRODUCTS, ASSETS } from "@/content/site";
import Reveal from "@/components/Reveal";
import ContextLine from "@/components/ContextLine";

export default function UpcomingProducts() {
  return (
    <section data-testid="upcoming-products-section" className="relative overflow-hidden" style={{ backgroundColor: "var(--navy)" }}>
      <img src={ASSETS.pattern} alt="" aria-hidden="true" width="1280" height="1280" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-30" />
      <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10 py-24 sm:py-32">
        <Reveal>
          <span className="eyebrow mb-6">منتجاتنا</span>
          <h2 className="font-display text-white leading-tight max-w-2xl" style={{ fontSize: "clamp(1.5rem, 2.9vw, 2.5rem)" }}>
            من منتجات سياق
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-8 max-w-xl relative">
          <ContextLine d="M600,-40 L600,40 M600,40 C600,80 300,70 300,120 M600,40 C600,80 900,70 900,120" viewBox="0 0 1200 130" className="absolute -top-16 inset-x-0 h-16 w-full pointer-events-none opacity-90" strokeWidth={2} />
          {PRODUCTS.map((product, i) => (
            <Reveal key={product.name} delay={i * 0.12}>
              <article className="border border-white/20 p-8 sm:p-10 min-h-40 flex flex-col items-start justify-between gap-7 backdrop-blur-sm" style={{ backgroundColor: "rgba(40,62,85,0.35)" }}>
                <h3 className="font-display text-white text-3xl">{product.name}</h3>
                {product.href ? (
                  <a href={product.href} target="_blank" rel="noreferrer" className="group inline-flex items-center gap-2 text-peach font-semibold hover:text-white transition-colors">
                    {product.cta}<ArrowLeft size={17} className="transition-transform group-hover:-translate-x-1" />
                  </a>
                ) : (
                  <span className="text-xs font-semibold px-3 py-1.5 border" style={{ color: "var(--peach)", borderColor: "var(--peach)" }} data-testid={`product-soon-${product.name}`}>{product.status}</span>
                )}
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
